export { default } from './go-tag-icon';
